// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1ScWQ","col":"styles_col__1VOGP"};